/**
 * Derive Site-ID Effort from activated site count.
 * 1–2 → Small, 3–10 → Medium, >10 → Large
 */
export const computeSiteIdEffort = (siteCount) => {
  const val = Number(siteCount);
  if (!Number.isFinite(val) || val < 1) return null;
  if (val <= 2) return "Small";
  if (val <= 10) return "Medium";
  return "Large";
};

/**
 * Normalize an Excel Site ID Effort cell (col C) into a usable string.
 * Uses cached formula results when present; ignores raw formula text (=...).
 */
export const normalizeSiteIdEffortFromExcel = (cellValue) => {
  if (cellValue == null || cellValue === "") return null;

  if (typeof cellValue === "object") {
    // SheetJS cell: prefer v/w/result, but skip empty strings from unevaluated formulas
    for (const key of ["v", "w", "result"]) {
      const raw = cellValue[key];
      if (raw == null || raw === "") continue;
      const text = String(raw).trim();
      if (text && !text.startsWith("=")) return text;
    }
    return null;
  }

  const text = String(cellValue).trim();
  if (!text || text.startsWith("=")) return null;
  return text;
};

/**
 * Read Site ID Effort from a SheetJS worksheet cell (column C).
 * Returns null when the cell is blank or an unevaluated formula.
 */
export const readSiteIdEffortFromWorksheetCell = (worksheet, excelRowNumber) => {
  if (!worksheet || !excelRowNumber) return null;
  return normalizeSiteIdEffortFromExcel(worksheet[`C${excelRowNumber}`]);
};

/**
 * Prefer an explicit Effort value (Excel cell / saved timeSiteIdSize).
 * Fall back to deriving from activated sites only when Effort is blank.
 */
export const resolveSiteIdEffort = (existingEffort, lower, upper) => {
  const normalized = normalizeSiteIdEffortFromExcel(existingEffort);
  if (normalized) return normalized;

  const siteCount =
    upper !== undefined &&
    upper !== null &&
    upper !== "" &&
    Number(upper) !== 0
      ? Number(upper)
      : Number(lower);

  return computeSiteIdEffort(siteCount);
};
